/* istanbul ignore file */
import CookieStore from 'ember-simple-auth/session-stores/cookie';
import config from 'dashboard/config/environment';

export default class ApplicationSessionStore extends CookieStore {
  cookieDomain: string | null =
    config.environment === 'production' ? '.showbie.com' : null;
}
